import React from "react";
import { useState, useEffect } from "react";
import Button from "../Components/FormComponents/Button";

export const VacancyCard = ({ filteredVacancies, msg }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(filteredVacancies);
  }, [filteredVacancies]);
  //To open the link
  const handleApply = (jobId) => {
    const url = `https://medha.zohorecruit.com/jobs/Careers/${jobId}`;
    window.open(url, "_blank", "noopener,noreferrer"); // Open the URL in a new tab
  };
  return (
    <div className="container mt-1 d-flex justify-content-center w-full max-w-[1440px] mx-auto">
      <div className="row w-100">
        <div className="col-12 p-0">
          <div style={{ backgroundColor: "white" }}>
            {msg ? (
              <p className="text-center">{data[0]?.data}</p>
            ) : (
              data?.map((job, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center justify-content-between position-relative"
                  style={{ padding: "15px 0" }}
                >
                  <div>
                    <p
                      className="mb-0 text-decoration-underline"
                      style={{
                        textUnderlineOffset: "5px",
                        fontFamily: "Lato, sans-serif",
                        color: "#31B89D",
                      }}
                    >
                      {job?.Remote_Job 
                        ? "Remote" 
                        : job?.City && job?.City.includes("Remote")
                          ? "Hybrid"
                          : "OnSite"}
                    </p>
                    <h6
                      className="text-grey mt-2"
                      style={{
                        fontSize: "30px",
                        fontWeight: "300",
                        fontStyle: "normal",
                        lineHeight: "34px",
                        marginBottom: "0rem",
                        fontFamily: "Lato, sans-serif",
                        color: "#666363",
                      }}
                    >
                      {job?.Job_Opening_Name}
                    </h6>

                    <p
                      className="mb-0"
                      style={{
                        fontSize: "16px",
                        fontWeight: "300",
                        fontStyle: "normal",
                        lineHeight: "26px",
                        fontFamily: "Lato, sans-serif",
                        color: "#666363",
                      }}
                    >
                      {job?.Department_Name?.name}
                    </p>

                    {job?.City && (
                      <p
                        className="mb-2"
                        style={{
                          fontSize: "16px",
                          fontWeight: "300",
                          fontStyle: "normal",
                          lineHeight: "26px",
                          fontFamily: "Lato, sans-serif",
                          color: "#666363",
                        }}
                      >
                        {job?.City}
                      </p>
                    )}
                  </div>

                  {/* Apply Button - Always in the same position on the right */}
                  <div
                    className="mt-2 mt-md-0 text-md-end"
                    style={{
                      flexShrink: 0, // Prevents it from shrinking
                      display: "flex",
                      alignItems: "center", // Center button vertically
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    {" "}
                    <Button
                      className="btn btn-primary w-100 w-md-auto"
                      onClick={() => handleApply(job?.id)}
                      variant="default"
                      label="Apply"
                    />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
